import React from 'react';
import { Building2, MoreHorizontal, Video } from 'lucide-react';
import { Card, CardContent } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
export interface BrandProfileCardProps {
  id: string;
  brandName: string;
  industry: string;
  targetAudience: string;
  brandVoice: string;
  keyMessages: string[];
  swipefileReferences: Array<{
    id: string;
    title: string;
    thumbnail: string;
  }>;
  onEdit?: (id: string) => void;
}
export function BrandProfileCard({
  id,
  brandName,
  industry,
  targetAudience,
  brandVoice,
  keyMessages,
  swipefileReferences,
  onEdit
}: BrandProfileCardProps) {
  return <Card className="border-gray-200 hover:shadow-lg transition-all duration-300 bg-white" data-id="element-178">
      <CardContent className="p-6" data-id="element-179">
        {/* Header */}
        <div className="flex items-start justify-between mb-4" data-id="element-180">
          <div className="flex items-center gap-3" data-id="element-181">
            <div className="h-12 w-12 rounded-lg bg-[#139191]/10 flex items-center justify-center" data-id="element-182">
              <Building2 className="h-6 w-6 text-[#139191]" data-id="element-183" />
            </div>
            <div data-id="element-184">
              <h3 className="font-bold text-lg text-gray-900" data-id="element-185">{brandName}</h3>
              <Badge variant="outline" className="text-xs border-gray-200 bg-gray-50 mt-1" data-id="element-186">
                {industry}
              </Badge>
            </div>
          </div>
          <Button variant="ghost" size="icon" className="h-8 w-8 text-gray-400 hover:text-gray-600" data-id="element-187">
            <MoreHorizontal className="h-4 w-4" data-id="element-188" />
          </Button>
        </div>

        {/* Details */}
        <div className="space-y-3 mb-4" data-id="element-189">
          <div data-id="element-190">
            <p className="text-xs font-semibold text-gray-500 mb-1" data-id="element-191">
              Target Audience
            </p>
            <p className="text-sm text-gray-700" data-id="element-192">{targetAudience}</p>
          </div>
          <div data-id="element-193">
            <p className="text-xs font-semibold text-gray-500 mb-1" data-id="element-194">
              Brand Voice
            </p>
            <p className="text-sm text-gray-700" data-id="element-195">{brandVoice}</p>
          </div>
          <div data-id="element-196">
            <p className="text-xs font-semibold text-gray-500 mb-1" data-id="element-197">
              Key Messages
            </p>
            <div className="flex flex-wrap gap-1.5" data-id="element-198">
              {keyMessages.map((message, idx) => <Badge key={idx} variant="outline" className="text-xs border-gray-200 bg-gray-50" data-id="element-199">
                  {message}
                </Badge>)}
            </div>
          </div>
        </div>

        {/* Swipefile References */}
        <div className="pt-4 border-t border-gray-100" data-id="element-200">
          <div className="flex items-center justify-between mb-3" data-id="element-201">
            <p className="text-xs font-semibold text-gray-700 flex items-center gap-1.5" data-id="element-202">
              <Video className="h-3.5 w-3.5 text-[#139191]" data-id="element-203" />
              Swipefile References ({swipefileReferences.length})
            </p>
          </div>
          <div className="grid grid-cols-3 gap-2" data-id="element-204">
            {swipefileReferences.slice(0, 3).map(ref => <div key={ref.id} className="relative bg-gray-100 rounded overflow-hidden" style={{
            aspectRatio: '9/16'
          }} data-id="element-205">
                <img src={ref.thumbnail} alt={ref.title} className="w-full h-full object-cover" data-id="element-206" />
              </div>)}
          </div>
          {swipefileReferences.length > 3 && <p className="text-xs text-gray-500 mt-2" data-id="element-207">
              +{swipefileReferences.length - 3} more
            </p>}
        </div>

        {/* Actions */}
        <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-208">
          <Button variant="outline" size="sm" className="w-full border-gray-200 hover:border-[#139191] hover:text-[#139191]" onClick={() => onEdit?.(id)} data-id="element-209">
            Edit Profile
          </Button>
        </div>
      </CardContent>
    </Card>;
}